import styled, { css } from 'styled-components';

const InlineStyled = styled.div`
  ${({ $style = {} }) => css`
    ${$style}
  `}
`;

export default InlineStyled;
